export default __webpack_public_path__ + "static/updatedesk001-7f497bb9f88cc794a26e16af28c0b65c.png";